export default "__VITE_ASSET__Dwf0VDUi__"